
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/matches/seen-all",
      function () {
        return require("private-next-pages/candidate/matches/seen-all/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/matches/seen-all"])
      });
    }
  